// extracted by mini-css-extract-plugin
module.exports = {"btnInfo":"ButtonInfo_btnInfo__qIRZz","btnBlock":"ButtonInfo_btnBlock__1ZK-V"};